// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"8deceaf9","278":"b7c734c1","388":"3bd99130","453":"3bfab5a3","537":"b031aee3","716":"ee2b316a"}[chunkId] + ".chunk.js";
};